module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Music-dca5f5e73da4695e229012e2d80958f9.svg";